// components
import DataChip from '../components/DataChip';
import type { EmployeeNameFormatTypes } from '../RosterPlan.types';

// styles
import { StyledTypographyFontMedium } from './useGetColumns.styles';

const flipToNegative = (num: number) =>
  num > 0 ? -Math.abs(num) : Math.abs(num);

export const dataChipValue = ({
  value,
  flipValue = false,
  tooltipValue = ''
}: {
  value: number | null | undefined;
  flipValue?: boolean;
  tooltipValue?: string;
}) => {
  if (!value && value !== 0) return '';

  const rounded = (Math.round(value * 100) / 100).toFixed(0);
  const dataChipValue = flipValue ? flipToNegative(+rounded) : +rounded;

  return value === 0 ? (
    <StyledTypographyFontMedium component="span">
      {value}
    </StyledTypographyFontMedium>
  ) : (
    <DataChip value={dataChipValue} prefix tooltipValue={tooltipValue} />
  );
};

export const formatEmployeeName = (
  row: any,
  format?: EmployeeNameFormatTypes
) => {
  switch (format) {
    case 'nameCompoundSurname':
      return row.nameCompoundSurname ?? '';
    case 'nameCompound':
      return row.nameCompound ?? '';
    case 'nameInformal':
      return row.nameInformal ?? '';
    case 'nameSurnameCompound':
      return row.nameSurnameCompound ?? '';
    default:
      return row.nameCompoundSurname ?? '';
  }
};
